var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn btn-primary block m-b",class:{ 'full-width': _vm.full },style:({ color: _vm.textBlack ? 'black' : '' }),attrs:{"type":"button","disabled":_vm.loading},on:{"click":_vm.onClickButton}},[(_vm.loading)?_c('i',{staticClass:"fas fa-circle-notch fa-spin"}):_vm._e(),(!_vm.loading)?_vm._t("default"):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }